export const COPY_ACTIVITY_SHARE_URL = 'COPY_ACTIVITY_SHARE_URL';
export const COPY_ACTIVITY_SHARE_URL_REQUEST = 'COPY_ACTIVITY_SHARE_URL_REQUEST';
export const COPY_ACTIVITY_SHARE_URL_SUCCESS = 'COPY_ACTIVITY_SHARE_URL_SUCCESS';
export const COPY_ACTIVITY_SHARE_URL_FAILURE = 'COPY_ACTIVITY_SHARE_URL_FAILURE';
